import React from 'react';

export default function MyContactsIcon({
  color,
  height,
  width,
}: {
  color?: string;
  height?: string;
  width?: string;
}) {
  return (
    <svg
      id="Controls_icon_MyContacts"
      data-name="Controls/icon/MyContacts"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '38'}
      height={height ?? '38'}
      viewBox="0 0 38 38"
    >
      <rect
        id="Rectangle_2340"
        data-name="Rectangle 2340"
        width="38"
        height="38"
        fill="none"
        opacity="0.002"
      />
      <path
        id="Path_3825"
        data-name="Path 3825"
        d="M36.262,23.335a6.83,6.83,0,0,0,1.75-4.611A6.226,6.226,0,0,0,32.1,12.239a6.071,6.071,0,0,0-5.773,5.08,5.46,5.46,0,0,0-4.771.044h0a6.088,6.088,0,0,0-5.788-5.124,6.226,6.226,0,0,0-5.915,6.485,6.83,6.83,0,0,0,1.75,4.611C9.6,24.2,5.93,26.292,5.93,30V30.6l.576.242c.778.315,1.5.673,2.214,1.01a15.655,15.655,0,0,0,5.476,1.835,5.445,5.445,0,0,0-.059.794v.608l.576.234c.778.322,1.5.673,2.205,1.017a14.291,14.291,0,0,0,6.611,1.9c2.43,0,5.482-.761,9.767-2.942l.508-.256v-.556a5.213,5.213,0,0,0-.08-.908h.011a26.49,26.49,0,0,0,7.7-2.767l.5-.256V30C41.93,26.292,38.258,24.2,36.262,23.335ZM32.1,14.069c2.229,0,4.046,2.086,4.046,4.655s-1.817,4.662-4.046,4.662a3.636,3.636,0,0,1-2.229-.776h0a6.7,6.7,0,0,0-1.81-4.026h0A4.358,4.358,0,0,1,32.1,14.069ZM26.211,19.4h0a4.871,4.871,0,0,1,1.817,3.879v.015a.779.779,0,0,1-.007.132,4.919,4.919,0,0,1-.546,2.189h0A4.142,4.142,0,0,1,25.1,27.749h0l-.239.073a3.245,3.245,0,0,1-.882.117,3.292,3.292,0,0,1-1-.154.994.994,0,0,1-.209-.066,4.164,4.164,0,0,1-2.243-2.027,5.1,5.1,0,0,1-.591-2.35v-.066a4.917,4.917,0,0,1,1.7-3.791,3.687,3.687,0,0,1,2.348-.864A3.636,3.636,0,0,1,26.211,19.4ZM15.764,14.069c2.221,0,4.031,2.064,4.046,4.619h0a6.709,6.709,0,0,0-1.7,3.828h0a3.669,3.669,0,0,1-2.348.871c-2.228,0-4.046-2.093-4.046-4.662S13.535,14.069,15.764,14.069ZM7.844,29.418c.464-2.73,4.068-4.267,5.212-4.684a8.544,8.544,0,0,0,2.707.593,8.38,8.38,0,0,0,2.475-.505h0a6.7,6.7,0,0,0,1.538,3.016h0A10.3,10.3,0,0,0,14.793,31.9l0,.011a13.387,13.387,0,0,1-5.239-1.7C9,29.952,8.443,29.681,7.844,29.418Zm9.9,5.286c-.546-.263-1.1-.534-1.7-.8a1.558,1.558,0,0,1,.034-.184H16.1a4.323,4.323,0,0,1,1.092-1.954l-.027,0,.013-.017a11.04,11.04,0,0,1,4.083-2.533,7.049,7.049,0,0,0,1.01.329l.015,0s0,.007,0,.01c.277.073.561.132.823.176a5.431,5.431,0,0,0,.875.088,5.9,5.9,0,0,0,.9-.1c.224-.037.456-.081.7-.139,0-.006,0-.011,0-.017a7.262,7.262,0,0,0,1.1-.355,10.706,10.706,0,0,1,4.18,2.657h.008a4.115,4.115,0,0,1,.979,1.859,2.151,2.151,0,0,1,.046.212C24.111,37.785,21.292,36.416,17.748,34.7Zm15.365-2.878h-.006l-.007-.014a10.419,10.419,0,0,0-4.918-3.966,6.729,6.729,0,0,0,1.537-2.989,8.448,8.448,0,0,0,2.378.468,8.544,8.544,0,0,0,2.707-.593c1.152.417,4.786,1.962,5.212,4.728A22.433,22.433,0,0,1,33.113,31.826Z"
        transform="translate(-4.93 -6.238)"
        fill={color}
      />
    </svg>
  );
}
